module.exports = __webpack_public_path__ + "img/G - 03.fe77db97.png";